import TemplateView from "../../../TemplateView";
import ButtonSeparator from "../../../taskManagement/tasksTable/ButtonSeparator";

export const SORT_BY = {
    TIME: "spentTime",
    USER: "formattedName"
};

export default class SortButtons extends TemplateView {

    constructor($containerEl, buttons) {
        super($containerEl);
        this.buttons = buttons;
    }

    templateHtml() {
        return "<div class='chartSortContainer'>" +
               "    <div><%=sortLabel%></div>" +
               "</div>"
    }

    messageKeys() {
        return {
            sortLabel: "report.create_chart.sort"
        }
    }

    afterRender() {
        const bLength = this.buttons.length;
        if (bLength === 0)
            return
        for (let i = 0; i < bLength - 1; i++) {
            this.buttons[i].init(this.$el);
            new ButtonSeparator(this.$el).init();
        }
        this.buttons[bLength - 1].init(this.$el);
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/SortButtons.js